import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { NAV_LINKS, COMPANY, LOGO_URL } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#0D1B2A]/95 backdrop-blur-xl shadow-2xl shadow-black/20 py-2'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-3 group"
        >
          <div className="bg-white rounded-xl px-3 py-1.5 shadow-lg shadow-black/10">
            <img
              src={LOGO_URL}
              alt={COMPANY.name}
              className="h-10 md:h-11 w-auto object-contain"
            />
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="px-4 py-2 text-sm text-white/70 hover:text-white font-medium tracking-wide transition-colors duration-300 relative group"
            >
              {link.label}
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-[#D4952B] group-hover:w-2/3 transition-all duration-300 rounded-full" />
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#contact')}
            className="ml-4 px-6 py-2.5 bg-[#D4952B] hover:bg-[#C08525] text-white text-sm font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-amber-900/20 hover:shadow-amber-800/40 hover:-translate-y-0.5"
          >
            Get in Touch
          </button>
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden p-2 text-white/80 hover:text-white transition-colors"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-4 bg-[#0D1B2A]/98 backdrop-blur-xl border-t border-white/5">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="block w-full text-left py-3 text-white/70 hover:text-white text-sm font-medium transition-colors border-b border-white/5 last:border-0"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#contact')}
            className="mt-4 w-full px-6 py-3 bg-[#D4952B] text-white text-sm font-semibold rounded-lg"
          >
            Get in Touch
          </button>
        </div>
      </div>
    </header>
  );
};
